import { useStaticQuery, graphql } from "gatsby";

import { Query } from "@graphql-types";

const AllSocialMediaQuery = (iban: string) => {
  const { allSanitySocialMedia }: Query = useStaticQuery(graphql`
    query SocialMediaQuery {
      allSanitySocialMedia {
        nodes {
          region {
            iban
          }
          nav {
            _key
            externalLink
            icon {
              provider
              name
              _type
              _key
            }
          }
        }
      }
    }
  `);

  if (allSanitySocialMedia == null) return null;

  const filteredSocials = allSanitySocialMedia.nodes.filter(item => {
    if (item.region == null) return null;
    if (item.region.iban === iban) return item;
    if (item.region.iban === process.env.GATSBY_DEFAULT_IBAN_REGION) return item;

    return null;
  });

  if (filteredSocials.length > 1) {
    return filteredSocials.find(item => item.region?.iban === iban);
  }

  return filteredSocials[0];
};

export default AllSocialMediaQuery;
